import useGetRentFiguresStats from './useGetRentFiguresStats'

export default useGetRentFiguresStats
